import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { SubHeading } from './investors/components';
import { IsOutBoundFundFlow } from '../utils/utilityFunctions';
import { useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';

const Officially_Valid_Document =
  'Document shall be deemed to be an Officially Valid Document even if there is a change in the name subsequent to its issuance, provided it is supported by a marriage certificate issued by the State Government or Gazette notification, indicating such a change of name.';

const OVD_Certificate =
  'Where certification of an OVD is done by the authorized officer of the Regulated Entity, such certified copy should be dated, signed and marked with ‘original sighted/verified’.';

const OVD_Contactable = 'The person certifying the OVD should be contactable.';

export const DocumentDeclaration =
  'I acknowledge that all of the measures mentioned above are taken.';

const styles = {
  content: {
    fontSize: 14,
    py: 1,
  },
  list: {
    fontSize: 14,
    py: 0.5,
  },
};

const Ul = ({ children, style }: { children: JSX.Element; style?: any }) => {
  return (
    <Typography
      component={'ul'}
      sx={{ pl: 0, display: 'flex', flexDirection: 'column', gap: 1, ...style }}>
      {children}
    </Typography>
  );
};

const Ol = ({
  children,
  style,
  type,
}: {
  children: JSX.Element;
  style?: any;
  type?: '1' | 'a' | 'i' | 'A' | 'I';
}) => {
  return (
    <Typography component={'ol'} style={style} type={type}>
      {children}
    </Typography>
  );
};
const JustifiedText = ({
  children,
  style,
  component = Typography,
}: {
  children: JSX.Element;
  style?: any;
  component?: React.ElementType;
}) => {
  return (
    <Typography
      sx={{
        textAlign: 'justify',
        //  ...styles.content
      }}
      style={style}
      component={component}>
      {children}
    </Typography>
  );
};
const Li = ({
  children,
  style,
}: {
  children: JSX.Element;
  style?: any;
  component?: React.ElementType;
}) => {
  return (
    <Typography
      sx={{
        textAlign: 'justify',
        //     ...styles.content,
        //     ...style,
      }}
      component={'li'}>
      {children}
    </Typography>
  );
};

const OriginalDocument = () => {
  const { application } = useSelector((store: RootStateType) => store.application);
  return (
    <>
      <JustifiedText>
        <>
          In case a customer is unable to produce, or it might not be possible for customer to
          submit original documents for verification (e.g., in situations where Regulated Entity has
          no physical contact with the customer, or the onboarding of customer is done through
          non-face to face mode); a Regulated Entity should obtain a copy of the OVD that is
          certified to be a ‘true copy’ and such certification may be carried out by any one of the
          following:
        </>
      </JustifiedText>
      {/* {IsOutBoundFundFlow(application?.fundFlowType || '') && (
        <JustifiedText>
          <>
            For Resident Individuals and Indian Entities, MFDs can authenticate documents; for other
            investors, authentication must be done by authorized personnel as per regulations which
            are as mentioned below.
          </>
        </JustifiedText>
      )} */}
      <Ol type="a">
        <>
          <Li>
            <>
              Authorised official of a bank located in a Financial Action Task Force (FATF)
              compliant jurisdiction with whom the individual has banking relationship;
            </>
          </Li>
          <Li>
            <>Notary Public (outside India);</>
          </Li>
          <Li>
            <>Court Magistrate (outside India);</>
          </Li>
          <Li>
            <>Judge (outside India);</>
          </Li>
          <Li>
            <>Certified public or professional accountant (outside India);</>
          </Li>
          <Li>
            <>Lawyer (outside India);</>
          </Li>
          <Li>
            <>
              The Embassy/Consulate General of the country of which the non-resident individual is a
              citizen; or
            </>
          </Li>
          <Li>
            <>any other authority as may be specified by the Authority.</>
          </Li>
        </>
      </Ol>
    </>
  );
};

const SubHeading2 = styled(SubHeading)(({ theme }) => ({
  backgroundColor: 'rgba(211, 47, 47, 0.1)',
  color: 'rgb(211, 47, 47)',
}));

export const IFSCGuidlines = () => {
  return (
    <Grid sx={{ width: '100%' }}>
      <SubHeading2>As per latest Guidelines of IFSC</SubHeading2>
      <Ol>
        <>
          <Li>
            <OriginalDocument />
          </Li>
          <Li>
            <Typography>{OVD_Contactable}</Typography>
          </Li>
          <Li>
            <Typography>{OVD_Certificate}</Typography>
          </Li>
          <Li>
            <Typography> {Officially_Valid_Document}</Typography>
          </Li>
        </>
      </Ol>
    </Grid>
  );
};
export const FatcaDeclarationInd = () => {
  return (
    <>
      <Ul style={{ listStyleType: 'none', display: 'flex', flexDirection: 'column', gap: 3 }}>
        <>
          <Li>
            <>
              I/We hereby declare that all information and particulars provided in this Application
              Form and accompanying documents are true, complete, and accurate. I/We undertake to
              promptly inform you of any changes to such information and to provide additional
              information or documentation as may be required from time to time by the FME, IFSCA,
              or any other regulatory authority.
            </>
          </Li>
          <Li>
            <>
              I/We confirm that the investment is made at my/our sole discretion, from legitimate
              sources, and that the funds legally belongs to me/us. I/We further confirm that no
              rebates, gifts, or inducements have been received, directly or indirectly, in
              connection with this investment. I/We understand that there is no assurance of returns
              in the Scheme.
            </>
          </Li>
        </>
      </Ul>
    </>
  );
};

const OutboundDeclarationTextInd = () => {
  return (
    <>
      <Ol>
        <>
          <Li>
            <>
              I/We hereby declare that all information and particulars provided in this Application
              Form and accompanying documents are true, complete, and accurate. I/We undertake to
              promptly inform you of any changes to such information and to provide additional
              information or documentation as may be required from time to time by the FME, IFSCA,
              or any other regulatory authority.
            </>
          </Li>
          <Li>
            <>
              I/We confirm that the investment is made at my/our sole discretion, from legitimate
              sources, and that the funds legally belongs to me/us. I/We further confirm that no
              rebates, gifts, or inducements have been received, directly or indirectly, in
              connection with this investment. I/We understand that there is no assurance of returns
              in the Scheme.
            </>
          </Li>
          <Li>
            <>
              I/We confirm that the investment complies with all applicable laws, including FEMA and
              relevant RBI regulations, and that I/we shall adhere to all reporting and disclosure
              requirements as may be prescribed from time to time.
            </>
          </Li>
          <Li>
            <>
              I/We agree to furnish any information required for due diligence and acknowledge that
              failure to provide such information may result in rejection of the application, return
              of funds, or reporting to applicable authorities.
            </>
          </Li>
          <Li>
            <>
              I/We authorize the FME and its authorised agents, intermediaries, and service
              providers to collect, use, process, share, and disclose my/our information, including
              with regulatory, statutory, judicial, or tax authorities (including FIU-IND), as
              required for compliance and operational purposes.
            </>
          </Li>
          <Li>
            <>
              I/We agree to indemnify the FME and its associates against any losses arising from
              incorrect, incomplete, or delayed information provided by me/us.
            </>
          </Li>
          <Li>
            <>
              I/We acknowledge that, in accordance with internal policies or procedure, I/we may be
              required to provide additional documentation, including in case of higher risk
              categorisation or enhanced due diligence. The FME reserves the right to inform the
              applicant/Distributor/Referral Agent of any request received from the investigators
              which can directly or indirectly impact the distribution/referral agent.
            </>
          </Li>
          <Li>
            <>
              I/We consent to the FME using my/our personal data for operational, reporting, and
              communication purposes, including sharing with affiliates and service providers, and
              for sending communications (including promotional communication, where consented).
            </>
          </Li>
          <Li>
            <>
              I/We confirm that I/we have read, understood, and agree to the terms of the Offer
              Document, applicable regulations (including IFSCA regulations, AML laws, and other
              applicable laws), and shall comply with the same as a Unitholder.
            </>
          </Li>
          <Li>
            <>
              I / hereby authorize the representatives of Marcellus Investment Managers Private
              Limited - IFSC Branch and its Associates - to contact me through any mode of
              communication. This will override registry on DND / DNDC , as the case may be. I/We
              confirm that the information provided in this form is true & accurate. I / We hereby
              authorise the Fund, FME and its Agents to disclose my / our details including
              investment details to my / our bank(s) / Fund&apos;s bank(s) and / or Distributor /
              Broker / Investment Adviser and to verify my / our bank details provided by me / us,
              or to disclose such service providers as deemed necessary for conduct of business. I
              hereby declare that the FME / Scheme can provide information to any institution / tax
              authorities / governmental body for the purpose of ensuring appropriate withholding
              from the account or any proceeds in relation thereto. I/We have read and understood
              the content of the KYM of the scheme. I have read and understood the terms,
              conditions, details, rules and regulations governing the scheme. I/We hereby declare
              that the amount invested in the scheme is through legitimate source only and does not
              involve designed for the purpose of the contravention of any Act, Rules, Regulations,
              Notifications or Directives of the provisions of the Income Tax Act, Anti Money
              Laundering Laws, Anti-Corruption Laws or any other applicable laws enacted by the
              Government of India from time to time. I/we have not received nor have been induced by
              any rebate or gifts, directly or indirectly in making this investment. I/We confirm
              that the funds invested in the Scheme, legally belongs to me/us. I/We hereby authorize
              the FME, to redeem the funds invested in the Scheme, in favour of the applicant, at
              the applicable NAV prevailing on the date of such redemption and undertake such other
              action with such funds that may be required by the law.
            </>
          </Li>
          <Li>
            <>
              I/We confirm that the KYC information obtained from CKYC or any authorized registry is
              true, complete, and up to date, and that there are no changes thereto. I/We consent to
              the Fund relying on such information for verification and ongoing compliance and
              undertake to promptly notify any changes.
            </>
          </Li>
        </>
      </Ol>
    </>
  );
};

const OutboundDeclarationTextNonInd = () => {
  return (
    <>
      <Ol>
        <>
          <Li>
            <>
              I/ We hereby declare that the amount invested in the Fund is through legitimate
              sources / channel only and does not involve and is not designed for the purpose of any
              contravention or evasion of any Act, Rules, Regulations, Notifications or Directions
              of the provisions of Income Tax Act, Foreign Exchange Management Act, Prevention of
              Money Laundering Act, Prevention of Corruption Act or any other applicable laws
              enacted by the Government of India or any Statutory Authority from time to time.
            </>
          </Li>
          <Li>
            <>
              I/ We agree to immediately inform you if there is any change in any of the information
              given in this application or in the appendices to this application. I/We also declare
              and agree that if any of the above statements are found to be incorrect or false or
              any information or particulars have been suppressed or omitted therefrom, the
              Investment Manager has a right to terminate the Contribution Agreement. I/We agree to
              submit any additional information required by the Investment Manager or SEBI promptly.
              Declaration for Sharing Client Investment Details: The client consents and authorizes
              the Investment Manager to share with Client&apos;s Introducer / Advisor / Referrer if
              any, as mentioned on account opening form, the details of any of the Client&apos;s
              accounts, assets, transactions and account relationship with the Investment Manager in
              connection with or pursuant to this Contribution Agreement and dealings between the
              Investment Manager and the Client.
            </>
          </Li>
          <Li>
            <>
              I/We hereby confirm that Marcellus Investment Managers Private Limited - IFSC Branch
              (&quot;FME&quot;) has not communicated in any manner for soliciting its schemes /
              products in my jurisdiction and I/We have based on my / our own discretion applied /
              invested in Retail scheme launched by FME. I/We are aware that FME have neither filed
              any of its constitution / scheme related documents nor registered its Units in any
              jurisdiction / region except India as stated in the Statement of Additional
              Information. I/We confirm that my/our application is in compliance with applicable
              Indian and foreign laws and I am /we are not prohibited from accessing capital markets
              under any order/ruling/judgment etc. of any jurisdiction /regulation. I/We understand
              and acknowledge that FME reserves the right to accept or reject any transactions and
              redeem any investments, at their sole discretion and as they may deem fit without
              assigning any reason thereto. I/We hereby authorize FME its employees, its agents, its
              Registrar to disclose, share, remit in any form/manner/mode information with respect
              to investments made by me/us and/or any part of it including the changes/updates that
              may be provided by me/us to its agents, third party service providers, IFSCA/SEBI
              registered intermediaries for the purposes of any Indian or foreign statutory,
              regulatory, judicial, quasi- judicial authorities/agencies requirements without any
              intimation/advice to me/us. I/ We hereby agree to provide any additional information /
              documentation to FME, its agents, employees, it&apos;s Registrar etc. that may be
              required in connection with the investments made by me/us. I/We shall indemnify FME
              and its Sponsor/Group/ Associates, its Officers/Directors/Employees in respect of any
              loss, cost, charge, expenses and such other claims which may be incurred in respect of
              any false, misleading, inaccurate and incomplete information in connection with my/our
              investments in the Scheme(s).
            </>
          </Li>
          <Li>
            <>
              I hereby authorize the representatives of Marcellus Investment Managers Private
              Limited - IFSC Branch and its Associates - to contact me through any mode of
              communication. This will override registry on DND/DNDC, as the case may be. I/We
              confirm that the information provided in this form is true & accurate. I/We hereby
              authorise the Fund, FME and its Agents to disclose my / our details including
              investment details to my / our bank(s) / Fund&apos;s bank(s) and / or Distributor /
              Broker/Investment Advisor and to verify my / our bank details provided by me / us, or
              to disclose to such service providers as deemed necessary for conduct of business. I
              hereby declare that the FME / Scheme can provide my information to any institution /
              tax authorities / governmental body for the purpose of ensuring appropriate
              withholding from the account or any proceeds in relation thereto. I/We have read and
              understood the content of the KIM of the scheme, I have read and understood the terms,
              conditions, details, rules and regulations governing the scheme. I/We hereby declare
              that the amount invested in the scheme is through legitimate source only and does not
              involve designed for the purpose of the contravention of any Act, Rules, Regulations,
              Notifications or Directives of the provisions of the Income Tax Act, Anti Money
              Laundering Laws, Anti-Corruption Laws or any other applicable laws enacted by the
              Government of India from time to time. I/we have not received nor have been induced by
              any rebate or gifts, directly or indirectly in making this investment. I/We confirm
              that the funds invested in the Scheme, legally belong to me/us. I/We hereby authorize
              the FME, to redeem the funds invested in the Scheme, in favour of the applicant, at
              the applicable NAV prevailing on the date of such redemption and undertake such other
              action with such funds that may be required by the law.
            </>
          </Li>
        </>
      </Ol>
    </>
  );
};

export const OutboundDeclarationInd = () => {
  return (
    <Grid sx={{ width: '100%', mt: 2 }}>
      <SubHeading2>Declarations and Signatures</SubHeading2>
      <OutboundDeclarationTextInd />
    </Grid>
  );
};

export const OutboundDeclarationNonInd = () => {
  return (
    <Grid sx={{ width: '100%', mt: 2 }}>
      <SubHeading2>Declarations and Signatures</SubHeading2>
      <OutboundDeclarationTextNonInd />
    </Grid>
  );
};
